<acf>
  return component('hero', [
    'label' => 'Hero Video',
    'sub_fields' => [
      fragment_field(),
      oembed_field(),
    ]
  ]);
</acf>

<php>
  return function ($content) {
    $content['field_Hero_video'] = wp_oembed_get($content['field_Hero_video']);

    return $content;
  };
</php>

<script>
  export default {
    props: ['content']
  }
</script>
<template>
  <section class="section" :id="content.field_Hero_fragment_id">
    <div class="container">
      <div class="video">
        <div class="embed-container" v-html="content.field_Hero_video"></div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .section {
    padding: 1rem 1.5rem;
    background: $pippin;
  }

  .container {
    text-align: center;
  }

  .video {
    max-width: 1041px;
    margin: 0 auto;
    width: 100%;
  }

  .embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; }
  .embed-container /deep/ iframe { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }

  @include desktop {
    .container {
      padding: 51px 0 131px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// components/Hero.vue